import { Component, OnInit, ViewChild, Input, ChangeDetectionStrategy,ChangeDetectorRef  } from '@angular/core';
import { ApiService } from 'src/app/service/api.service';
import { MatPaginator } from '@angular/material/paginator';
import { Router} from '@angular/router';
@Component({
  selector: 'app-list-company',
  templateUrl: './list-company.component.html',
  styleUrls: ['./list-company.component.css', '../../../assets/styles/table.css', '../../../assets/styles/panel.css','../../../assets/styles/text-title.css','../../../assets/styles/button.css','../../../assets/styles/body.css']
})
export class ListCompanyComponent implements OnInit {
  dataSourceCompany: any;
  public loadListCompany = false
  p: number = 1;
  total: number
  term: string;
  tmp: string;
  count: number = 50;
  constructor(private apiService : ApiService, 
    private cdRef:ChangeDetectorRef,
    public router: Router,
    ) { }

  ngOnInit(): void {
    this.apiService.getCompanies().subscribe(companies => { 
      if (companies != 400){
        this.dataSourceCompany = companies;
        this.loadListCompany = true
        this.cdRef.detectChanges();
      }
    })
  }

  findCompany(){
    this.apiService.getCompanyPaginateFilter(this.tmp, this.count).subscribe(res => {
      if (res.total > 0){
        this.total = res.total;
        this.dataSourceCompany = res.company
        this.p = 1
        this.cdRef.detectChanges();
      }
    })
  }

  opencompanyDetailInNewWindow(id : any) {
    const url = this.router.serializeUrl(
      this.router.createUrlTree([`/detail-company/${id}`])
    );
    window.open(url, '_blank');
  }

}
